import { connect } from 'react-redux';
import React, { PropTypes } from 'react';
import { updateData } from '../actions/form';
import { Button, Icon, Form, Table, Segment } from 'semantic-ui-react';
import Modal from 'modules/common/components/Modal';
import dotProp from 'dot-prop-immutable';

export class Analysis extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      modalOpened: false,
      currentLine: this.emptyLine(),
    };

    this.addClick = this.addClick.bind(this);
    this.onClose = this.onClose.bind(this);
    this.updateField = this.updateField.bind(this);
  }

  emptyLine() {
    return {
      id: undefined,
      place: '',
      level: '',
      damageLocation: '',
      activity: false,
      comment: '',
    };
  }

  addClick() {
    this.setState({
      ...this.state,
      modalOpened: true,
      currentLine: this.emptyLine(),
      currentIndex: -1,
    });
  }

  updateClick(index) {
    this.setState({
      ...this.state,
      currentLine: this.props.lines[index],
      currentIndex: index,
      modalOpened: true,
    });
  }

  onSave(index, line) {
    const updatedLines = this.props.lines ? [...this.props.lines] : [];
    if (index === -1) {
      updatedLines.push(line);
    } else {
      updatedLines[index] = line;
    }
    this.props.updateLines(updatedLines);
    this.onClose();
  }

  onDelete(index) {
    const updatedLines = [...this.props.lines];
    updatedLines.splice(index, 1);
    this.props.updateLines(updatedLines);
  }

  onClose() {
    this.setState({
      ...this.state,
      modalOpened: false,
    });
  }

  updateField(name, value) {
    this.setState(dotProp.set(this.state, `currentLine.${name}`, value));
  }

  render() {
    return (
      <div>
        <Form.Field style={{ marginBottom: '20px' }}>
          <label>Analyse de la situation</label>
          <Button
            icon
            labelPosition="left"
            floated="right"
            style={{ marginBottom: '5px' }}
            onClick={this.addClick}
            disabled={this.props.readOnly}
          >
            <Icon name="add" />
            Ajouter
          </Button>
          {this.props.lines && this.props.lines.length > 0 && (
            <Table compact>
              <Table.Header>
                <Table.Row key="head">
                  <Table.HeaderCell>Lieu</Table.HeaderCell>
                  <Table.HeaderCell>Niveau</Table.HeaderCell>
                  <Table.HeaderCell>Localisation des dégâts</Table.HeaderCell>
                  <Table.HeaderCell>Activité</Table.HeaderCell>
                  <Table.HeaderCell>Commentaire</Table.HeaderCell>
                  <Table.HeaderCell />
                </Table.Row>
              </Table.Header>

              <Table.Body>
                {this.props.lines.map((line, index) => (
                  <Table.Row key={index}>
                    <Table.Cell> {line.place}</Table.Cell>
                    <Table.Cell> {line.level}</Table.Cell>
                    <Table.Cell> {line.damageLocation}</Table.Cell>
                    <Table.Cell>
                      {' '}
                      {line.activity && (
                        <Icon color="green" name="checkmark" size="large" />
                      )}
                    </Table.Cell>
                    <Table.Cell> {line.comment}</Table.Cell>
                    <Table.Cell>
                      {' '}
                      <Button
                        basic
                        icon="edit"
                        onClick={() => this.updateClick(index)}
                        disabled={this.props.readOnly}
                      />{' '}
                      <Button
                        basic
                        icon="trash"
                        onClick={() => this.onDelete(index)}
                        disabled={this.props.readOnly}
                      />{' '}
                    </Table.Cell>
                  </Table.Row>
                ))}
              </Table.Body>
            </Table>
          )}
          {(!this.props.lines || this.props.lines.length === 0) && (
            <Segment style={{ backgroundColor: '#f9fafb', clear: 'both' }}>
              Aucune ligne
            </Segment>
          )}
        </Form.Field>
        <Modal
          isOpened={this.state.modalOpened}
          onClose={this.onClose}
          closable
        >
          <div className="header">Analyse</div>
          <div className="content">
            <Form>
              <Form.Input
                label="Lieu"
                value={this.state.currentLine.place}
                onChange={(_, value) => this.updateField('place', value.value)}
                readOnly={this.props.readOnly}
              />
              <Form.Input
                label="Niveau"
                value={this.state.currentLine.level}
                onChange={(_, value) => this.updateField('level', value.value)}
                readOnly={this.props.readOnly}
              />
              <Form.Input
                label="Localisation des dégâts"
                value={this.state.currentLine.damageLocation}
                onChange={(_, value) =>
                  this.updateField('damageLocation', value.value)
                }
                readOnly={this.props.readOnly}
              />
              <Form.Checkbox
                label="Activité"
                checked={this.state.currentLine.activity}
                onClick={() =>
                  this.updateField('activity', !this.state.currentLine.activity)
                }
                readOnly={this.props.readOnly}
              />
              <Form.Input
                label="Commentaire"
                value={this.state.currentLine.comment}
                onChange={(_, value) =>
                  this.updateField('comment', value.value)
                }
                readOnly={this.props.readOnly}
              />
            </Form>
          </div>
          <div className="actions">
            <button
              className="ui primary button"
              onClick={() =>
                this.onSave(this.state.currentIndex, this.state.currentLine)
              }
              disabled={this.props.readOnly}
            >
              <i className="icon save" />
              Enregistrer
            </button>
          </div>
        </Modal>
      </div>
    );
  }
}

Analysis.propTypes = {
  lines: PropTypes.array,
  updateLines: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) => ({
  lines: state.form.form.diagnosticAnalysis,
});

const mapDispatchToProps = (dispatch, ownProps) => ({
  updateLines: lines => dispatch(updateData('diagnosticAnalysis', lines)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Analysis);



// WEBPACK FOOTER //
// ./src/modules/saas/aast/case-study/components/Analysis.js